export default __webpack_public_path__ + "static/media/M.2.2.db200ee0.svg";